// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","personalDetailsList":"uo8rEc6eafUYt75a8QTUG"};